import React, { useEffect, useImperativeHandle, useState } from 'react';
import { useAlert } from 'react-alert';
import { useDispatch } from 'react-redux';
import StorageItemsList from 'scenes/Storage/components/StorageItemsList';
import StorageUpdateModal from 'scenes/Storage/components/StorageUpdateModal';
import { getStorageItems } from 'services/apiRequests/storage.api';
import { getGlobalSettings } from 'services/store/actions/settings';
import { setSpinner } from 'services/store/actions/view';

const StorageTab = () => {
  const dispatch = useDispatch();
  const alert = useAlert();
  const [storageItems, setStorageItems] = useState([]);
  const [isUpdateModal, setIsUpdateModal] = useState(false);
  const [updatingItem, setUpdatingItem] = useState(null);

  const fetchStorageItems = async () => {
    try {
      const data = await getStorageItems();
      setStorageItems(data.items);
    } catch (error) {
      alert.error('Błąd pobierania elementów magazynowych');
    }
  };

  useEffect(() => {
    dispatch(setSpinner(true));
    Promise.all([
      dispatch(
        getGlobalSettings(
          () => {},
          () => {
            alert.error('Błąd!');
          },
        ),
      ),
      fetchStorageItems(),
    ]).finally(() => {
      dispatch(setSpinner(false));
    });
  }, []);

  const handleModalSuccess = () => {
    fetchStorageItems();
  };
  const handleCloseUpdateModal = () => {
    setIsUpdateModal(false);
    setUpdatingItem(null);
  };
  const handleUpdateQuantity = (item) => {
    setUpdatingItem(item);
    setIsUpdateModal(true);
  };
  return (
    <div>
      <StorageItemsList
        items={storageItems}
        onUpdateQuantity={handleUpdateQuantity}
        showDesiredQuantity={false}
        showMinQuantity={false}
        showPrice={false}
      />
      {/* MODALS */}
      {isUpdateModal && (
        <StorageUpdateModal
          show={isUpdateModal}
          onHide={handleCloseUpdateModal}
          item={updatingItem}
          onSuccess={handleModalSuccess}
        />
      )}
    </div>
  );
};

export default StorageTab;
